module.exports = __webpack_public_path__ + "img/tb.d5992485.png";